import { React, useState, useEffect } from 'react';
import styled from 'styled-components';
import { useHistory } from 'react-router-dom';
import Lottie from 'lottie-react';
import moment from 'moment';

import MemberList from './MemberList';

import Duration from '../../../image/DurationImage.png';
import NewImage from '../../../image/NewImage.png';
import AgeRangeIcon from '../../../image/AgeRangeIcon.png';
import CurrentTimerIcon from '../../../image/CurrentTimerIcon.png';

import LoadingAnimation from '../../../Animation/LoadingAnimation.json';

import { useLanguage } from '../../../Context/LanguageContext';

export default function MemberEngagementView(props) {
  const {
    startDate,
    endDate,
    calcDateText,
    engagementReserves,
    selectedPartnerGym,
    isOpenPartnerGymSales,
    isEngagementLoading,
    setIsEngagementLoading
  } = props;

  const history = useHistory();
  const { t } = useLanguage();

  // 생년월일 포맷 //
  function formatBirthDay(bd) {
    const y = bd.slice(0, 4), m = bd.slice(4, 6), d = bd.slice(6, 8);
    const order = t('statistics.calendar.dateOrder');
    const sep = t('statistics.calendar.dateSeparator');
    if (order === 'MDY') return m + sep + d + sep + y;
    return y + sep + m + sep + d;
  }

  // ISO 날짜 포맷 //
  function formatIsoDate(iso) {
    const parts = iso.split('T')[0].split('-');
    const order = t('statistics.calendar.dateOrder');
    const sep = t('statistics.calendar.dateSeparator');
    if (order === 'MDY') return parts[1] + sep + parts[2] + sep + parts[0];
    return parts[0] + sep + parts[1] + sep + parts[2];
  }

  const [engagementStates, setEngagementStates] = useState([]);
  const [engagementTotalCount, setEngagementTotalCount] = useState(1);
  const [engagementMaxCount, setEngagementMaxCount] = useState(0);
  const [engagementMaxText, setEngagementMaxText] = useState('');

  // 연령별 이용자 분석 및 출석 현황 정리 //
  useEffect(() => {
    let year = parseInt(moment().format('YYYY'));
    let startChildren = year - 8;

    let startTeenager = year - 18;
    let endTeenager = year - 9;

    let startTewnties = year - 28;
    let endTewnties = year - 19;

    let startThirties = year - 38;
    let endThirties = year - 29;

    let startForties = year - 48;
    let endForties = year - 39;

    let startFifties = year - 58;
    let endFifties = year - 49;

    let startSixties = year - 68;
    let endSixties = year - 59;

    let startSeventies = year - 78;
    let endSeventies = year - 69;

    let startEighties = year - 88;
    let endEighties = year - 79;

    let startNineties = year - 98;
    let endNineties = year - 89;

    let engagementStateList = [
      {
        text: t('statistics.engagement.ageUnder10'),
        startYear: startChildren,
        endYear: year,
        totalCount: 0,
        usages: []
      },
      {
        text: t('statistics.engagement.age10s'),
        startYear: startTeenager,
        endYear: endTeenager,
        totalCount: 0,
        usages: []
      },
      {
        text: t('statistics.engagement.age20s'),
        startYear: startTewnties,
        endYear: endTewnties,
        totalCount: 0,
        usages: []
      },
      {
        text: t('statistics.engagement.age30s'),
        startYear: startThirties,
        endYear: endThirties,
        totalCount: 0,
        usages: []
      },
      {
        text: t('statistics.engagement.age40s'),
        startYear: startForties,
        endYear: endForties,
        totalCount: 0,
        usages: []
      },
      {
        text: t('statistics.engagement.age50s'),
        startYear: startFifties,
        endYear: endFifties,
        totalCount: 0,
        usages: []
      },
      {
        text: t('statistics.engagement.age60s'),
        startYear: startSixties,
        endYear: endSixties,
        totalCount: 0,
        usages: []
      },
      {
        text: t('statistics.engagement.age70s'),
        startYear: startSeventies,
        endYear: endSeventies,
        totalCount: 0,
        usages: []
      },
      {
        text: t('statistics.engagement.age80s'),
        startYear: startEighties,
        endYear: endEighties,
        totalCount: 0,
        usages: []
      },
      {
        text: t('statistics.engagement.age90s'),
        startYear: startNineties,
        endYear: endNineties,
        totalCount: 0,
        usages: []
      },
    ];

    for (let i = 0; i < engagementReserves.length; i++) {
      let birthYear = parseInt(engagementReserves[i].birthDay.slice(0, 4));

      for (let j = 0; j < engagementStateList.length; j++) {
        if (engagementStateList[j].startYear <= birthYear && birthYear <= engagementStateList[j].endYear) {
          let isExist = false;

          for (let h = 0; h < engagementStateList[j].usages.length; h++) {
            if (engagementStateList[j].usages[h].membershipId === engagementReserves[i].membershipId) {
              engagementStateList[j].totalCount += 1;
              engagementStateList[j].usages[h].count += 1;
              isExist = true;
              break;
            }
          }

          if (!isExist) {
            engagementStateList[j].totalCount = 1;

            engagementStateList[j].usages.push({
              membershipId: engagementReserves[i].membershipId,
              membershipName: engagementReserves[i].membershipName,
              count: 1
            });
          }
        }
      }
    }

    let finalEngagementStates = [];
    let totalCount = 1;
    let maxText = t('statistics.engagement.ageUnder10');
    let maxCount = 0;

    for (let i = 0; i < engagementStateList.length; i++) {
      if (engagementStateList[i].usages.length > 0) {
        engagementStateList[i].usages.sort((a, b) => b.count - a.count || a.membershipId - b.membershipId);
        finalEngagementStates.push(engagementStateList[i]);
        totalCount += engagementStateList[i].totalCount;

        if (engagementStateList[i].totalCount > maxCount) {
          maxText = engagementStateList[i].text;
          maxCount = engagementStateList[i].totalCount;
        }
      }
    }

    setEngagementTotalCount(totalCount);
    setEngagementMaxCount(maxCount);
    setEngagementMaxText(maxText);
    setEngagementStates(finalEngagementStates);
    setIsEngagementLoading(false);
  }, [engagementReserves])


  // 수업 이름 표기 //
  function decideLessonName(data) {
    let classStartTime = data.classTime.split('-')[0];

    return classStartTime + ' ' + data.lessonName;
  }

  return (
    <TopLevelWrapper>
      <InfoBox>
        <Title>{calcDateText() + ' ' + t('statistics.engagement.ageAnalysis')}</Title>
        {
          isEngagementLoading ?
            <AnimationBox>
              <LottieWrapper>
                <Lottie animationData={LoadingAnimation} loop={true} />
              </LottieWrapper>
            </AnimationBox>
            :
            <InnerInfoBox>
              {
                isOpenPartnerGymSales ?
                  <InfoView>
                    <ImageBoxWrapper gap={8}>
                      <AgeRangeImage src={AgeRangeIcon} />
                      <ColorTextBox backgroundColor='#6DD49E'>
                        <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#FFFFFF' hover='default'>{t('statistics.engagement.mostAge')}</Text>
                        <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#FFFFFF' hover='default'>:</Text>
                        <Text fontFamily='NotoSansKR-Bold' fontSize={14} color='#FFFFFF' hover='default'>{engagementMaxText + ' ' + (engagementMaxCount / engagementTotalCount * 100).toFixed(2) + '%'}</Text>
                      </ColorTextBox>
                    </ImageBoxWrapper>
                    <MemberBoxWrapper>
                      <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#595959' hover='default'>{t('statistics.engagement.ageUsageStats')}</Text>
                      <MemberBox>
                        <MemberColumn>
                          <Text style={{ marginRight: `88px` }} fontFamily='NotoSansKR-Regular' fontSize={14} color='#777777' hover='default'>{t('statistics.engagement.colAge')}</Text>
                          <Text style={{ marginRight: `200px` }} fontFamily='NotoSansKR-Regular' fontSize={14} color='#777777' hover='default'>{t('statistics.engagement.colMembership')}</Text>
                          <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#777777' hover='default'>{t('statistics.engagement.colUsageCount')}</Text>
                        </MemberColumn>
                        <MemberListView>
                          {
                            engagementStates.map((data, index) => (
                              <EngagementUsageBox
                                key={'EngagementState-' + index}
                                isFirst={index === 0}
                                isLast={index === (engagementStates.length - 1)}>
                                <RangeBox height={30 * (data.usages.length)}>
                                  <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#777777' hover='default'>{data.text}</Text>
                                  {/* {data.usages.length > 1 && <Text fontFamily='NotoSansKR-Regular' fontSize={10} color='#777777' hover='default'>{data.startYear + '-' + data.endYear}</Text>} */}
                                  {<Text fontFamily='NotoSansKR-Regular' fontSize={10} color='#777777' hover='default'>{data.startYear + '-' + data.endYear}</Text>}
                                </RangeBox>
                                <EngagementMembershipBoxWrapper>
                                  {
                                    data.usages.map((usage, usageIndex) => (
                                      <EngagementInfoBox
                                        key={'EngagementUsage-' + usageIndex}
                                        isFirst={(index === 0 || usageIndex === 0)}
                                        isLast={(index === (engagementStates.length - 1)) || (usageIndex === (data.usages.length - 1))}>
                                        <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#777777' hover='default'>{usage.membershipName}</Text>
                                      </EngagementInfoBox>
                                    ))
                                  }
                                </EngagementMembershipBoxWrapper>
                                <EngagementMembershipCountBoxWrapper>
                                  {
                                    data.usages.map((usage, usageIndex) => (
                                      <EngagementInfoBox
                                        key={'EngagementUsage-' + usageIndex}
                                        isFirst={(index === 0 || usageIndex === 0)}
                                        isLast={(index === (engagementStates.length - 1)) || (usageIndex === (data.usages.length - 1))}>
                                        <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#777777' hover='default'>{usage.count.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + t('statistics.countUnit')}</Text>
                                      </EngagementInfoBox>
                                    ))
                                  }
                                </EngagementMembershipCountBoxWrapper>
                              </EngagementUsageBox>
                            ))
                          }
                        </MemberListView>
                      </MemberBox>
                    </MemberBoxWrapper>
                  </InfoView>
                  :
                  <NotOpenTextWrapper>
                    <Text fontFamily='NotoSansKR-Bold' fontSize={15} color='#444444' cursor='default'>{t('statistics.partnerGymPrivate')}</Text>
                    <Text fontFamily='NotoSansKR-Regular' fontSize={15} color='#444444' cursor='default'>{t('statistics.partnerGymPrivateDesc')}</Text>
                  </NotOpenTextWrapper>
              }
            </InnerInfoBox>
        }
      </InfoBox>

      <BoxDivisionLine />

      <InfoBox>
        <Title>{calcDateText() + ' ' + t('statistics.engagement.realtimeAttendance')}</Title>
        {
          isEngagementLoading ?
            <AnimationBox>
              <LottieWrapper>
                <Lottie animationData={LoadingAnimation} loop={true} />
              </LottieWrapper>
            </AnimationBox>
            :
            <InnerInfoBox>
              {
                isOpenPartnerGymSales ?
                  <InfoView>
                    <ImageBoxWrapper gap={8}>
                      <CurrentTimerImage src={CurrentTimerIcon} />
                      <ColorTextBox backgroundColor='#FF7575'>
                        <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#FFFFFF' hover='default'>{t('statistics.engagement.totalVisitCount')}</Text>
                        <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#FFFFFF' hover='default'>:</Text>
                        <Text fontFamily='NotoSansKR-Bold' fontSize={14} color='#FFFFFF' hover='default'>{engagementReserves.length.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',') + t('statistics.countUnit')}</Text>
                      </ColorTextBox>
                    </ImageBoxWrapper>
                    <MemberBoxWrapper>
                      <Text fontFamily='NotoSansKR-Medium' fontSize={14} color='#595959' hover='default'>{t('statistics.engagement.realtimeVisitTime')}</Text>
                      <MemberBox>
                        <MemberColumn>
                          <MemberColumnWrapper width={66}>
                            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#777777' hover='default'>{t('statistics.engagement.colName')}</Text>
                          </MemberColumnWrapper>
                          <MemberColumnWrapper width={60}>
                            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#777777' hover='default'>{t('statistics.engagement.colGender')}</Text>
                          </MemberColumnWrapper>
                          <MemberColumnWrapper width={90}>
                            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#777777' hover='default'>{t('statistics.engagement.colBirth')}</Text>
                          </MemberColumnWrapper>
                          <MemberColumnWrapper width={144}>
                            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#777777' hover='default'>{t('statistics.engagement.colClass')}</Text>
                          </MemberColumnWrapper>
                          <MemberColumnWrapper width={60}>
                            <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#777777' hover='default'>{t('statistics.engagement.colAttendanceDate')}</Text>
                          </MemberColumnWrapper>
                        </MemberColumn>
                        <MemberListView>
                          {
                            engagementReserves.map((data, index) => (
                              <EngagementMemberWrapper key={'EngagementCurrent-' + index}>
                                <EngagementTextBox width={59}>
                                  <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#777777' hover='pointer'>{data.userName}</Text>
                                </EngagementTextBox>
                                <EngagementTextBox width={50}>
                                  <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#777777' hover='pointer'>{data.gender === 'male' ? t('statistics.male') : t('statistics.female')}</Text>
                                </EngagementTextBox>
                                <EngagementTextBox width={84}>
                                  <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#777777' hover='pointer'>{formatBirthDay(data.birthDay)}</Text>
                                </EngagementTextBox>
                                <EngagementTextBox width={134}>
                                  <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#777777' hover='pointer'>{decideLessonName(data)}</Text>
                                </EngagementTextBox>
                                <EngagementTextBox width={72}>
                                  <Text fontFamily='NotoSansKR-Regular' fontSize={14} color='#777777' hover='pointer'>{formatIsoDate(data.classDate)}</Text>
                                </EngagementTextBox>
                              </EngagementMemberWrapper>
                            ))
                          }
                        </MemberListView>
                      </MemberBox>
                    </MemberBoxWrapper>
                  </InfoView>
                  :
                  <NotOpenTextWrapper>
                    <Text fontFamily='NotoSansKR-Bold' fontSize={15} color='#444444' cursor='default'>{t('statistics.partnerGymPrivate')}</Text>
                    <Text fontFamily='NotoSansKR-Regular' fontSize={15} color='#444444' cursor='default'>{t('statistics.partnerGymPrivateDesc')}</Text>
                  </NotOpenTextWrapper>
              }
            </InnerInfoBox>
        }
      </InfoBox>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 1020px;
  height: 448px;

  gap: 28px;
  margin-top: 38px;

  border-radius: 30px;
  box-shadow: 0 40px 50px rgba(240, 232, 227, 0.5);
  background-color: #FFFFFF;
`;

const BoxDivisionLine = styled.div`
  diplay: flex;
  flex-direction: row;

  width: 1px;
  height: 392px;

  background-color: #ECECEC;
`;

const InnerInfoBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100%;
  height: 364px;
`;

const InfoBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-conetent: center;
  align-items: flex-start;

  width: 454px;
`;

const InfoView = styled.div`
  display: flex;
  flex-direction: column;

  justify-conetent: center;
  align-items: flex-start;
`;

const Title = styled.p`
  font-family: NotoSansKR-Medium;
  font-size: 14px;

  color: #232323;

  margin: 0 0 0 0;
`;

const AnimationBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  z-index: 5;
  
  width: 100%;
  height: 364px;

  background-color: #FFFFFF;
`;

const LottieWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 80px;
  height: 80px;
`;

const ImageBoxWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;eeeee

  margin-top: 24px;

  gap: ${props => props.gap}px;
`;

const AgeRangeImage = styled.img`
  width: 24px;
  height: 24px;
`;

const CurrentTimerImage = styled.img`
  width: 30px;
  height: 30px;
`;

const ColorTextBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  padding: 0px 10px 0px 10px;

  height: 28px;

  gap: 4px;

  border-radius: 8px;
  background-color: ${props => props.backgroundColor};
`;

const MemberBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  margin-top: 24px;
`;

const MemberBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  margin-top: 10px;

  width: 454px;
  height: 240px;
`;

const MemberColumn = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  padding: 0px 8px 0px 8px;

  width: calc(100% - 16px);
  height: 32px;

  border-radius: 8px 8px 0px 0px;
  background-color: #ECECEC;
`;

const MemberColumnWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  width: ${props => props.width}px;
  height: 20px;

  overflow: hidden;
`;

const MemberListView = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;
  height: 216px;

  overflow-y: scroll;
  overflow-x: none;

  &::-webkit-scrollbar {
    width: 2px;
  }

  &::-webkit-scrollbar-thumb {
		border: 3px solid transparent;
		background-color: #DADADA;
		border-radius: 200px;
	}

  &::-webkit-scrollbar-track {
		background-color: #FFFFFF;
		border-radius: 200px;
	}
`;

const EngagementMemberWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  padding: 0px 8px 0px 8px;

  gap: 8px;

  width: calc(100% - 16px);
  min-height: 36px;
  max-height: 36px;

  background-color: #FFFFFF;

  &:hover {
    cursor: pointer;

    border-radius: 5px;
    background-color: #ECECEC;
  }

  transition: all 0.3s ease-in-out;
`;

const EngagementTextBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: ${props => props.width}px;
  height: 20px;

  overflow: hidden;
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  &:hover {
    cursor: ${props => props.hover};
  }
`;

const NotOpenTextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: 100%;
`;

const EngagementUsageBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;

  border-top: ${props => props.isFirst ? `0px solid #FFFFFF` : `0.5px solid #FBFBFB`};
  border-bottom: ${props => props.isLast ? `0px solid #FFFFFF` : `0.5px solid #FBFBFB`};
`;

const RangeBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: calc(25% - 1px);
  height: ${props => props.height}px;

  border-right: 1px solid #FBFBFB;
`;

const EngagementMembershipBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 59%;
`;

const EngagementInfoBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  padding: 0px 10px;

  width: calc(100% - 20px);
  height: ${props => (props.isFirst || props.isLast) ? 29 : 30}px;

  border-top: ${props => props.isFirst ? `0px solid #FFFFFF` : `0.5px solid #FBFBFB`};
  border-bottom: ${props => props.isLast ? `0px solid #FFFFFF` : `0.5px solid #FBFBFB`};

  overflow: hidden;
`;

const EngagementMembershipCountBoxWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: calc(16% - 1px);

  border-left: 1px solid #FBFBFB;
`;